export const CHANNELS = [
    { key: 'email', label: 'Email' },
    { key: 'gchat', label: 'Google Chat' },
    { key: 'in_app', label: 'In-app' },
];

export const CHANNEL_LABELS = CHANNELS.reduce((acc, c) => {
    acc[c.key] = c.label;
    return acc;
}, {});

export const FREQUENCY_LABELS = {
    immediate: 'Immediate',
    hourly: 'Every hour (digest)',
    four_hourly: 'Every 4 hours (digest)',
    off: "Off — don't notify me",
};
